/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';

// import { createRouter, createWebHistory } from 'vue-router'

Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        name: 'healthcheck.index',
        component: () => import ("@/views/healthcheck/Index.vue")
    }
];

const router = new VueRouter({
    mode: 'history',
    // base: process.env.BASE_URL,
    routes,
});

export default router